import { UseFirstRender } from '@/hooks';
import { resetForgotPassword } from '@/store/actions';
import { Box, IconButton, Theme, Typography, useMediaQuery } from '@mui/material';
import { Forgot } from './components';
import CheckEmail from './components/checkEmail';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector, forgotSelector } from '@/store/selectors';
import { useRouter } from 'next/router';
import Image from 'next/image';

export const ForgotPassword = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const authData = useSelector(authSelector);
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const [loading, setLoading] = useState(true);
  const [showthread, SetShowThread] = useState(false);
  const [email, SetEmail] = useState('');
  const { step } = useSelector(forgotSelector);

  useEffect(() => {
    if (authData?.recover?.message?.toLowerCase()?.includes('email')) SetShowThread(true);
  }, [authData?.recover]);

  const showScreen = () => {
    switch (step) {
      case 1:
        return <Forgot />;
      case 2:
        return <CheckEmail />;
      default:
        return <Forgot />;
    }
  };

  UseFirstRender(() => {
    dispatch(resetForgotPassword());
  }, []);

  return (
    <Box
      display={'flex'}
      height={'100vh'}
      flexDirection={'column'}
      width={'100%'}
      zIndex={1}
      position={'relative'}
      padding={'0 1rem'}
      paddingTop={'46px'}
      justifyContent={'center'}
      alignItems={'center'}>
      <IconButton
        disableRipple
        onClick={(e) => router.push('/')}
        sx={{ position: 'absolute', top: '1rem', left: isMobile ? '1rem' : '20rem' }}>
        <Image width={24} height={24} alt='back' color='black' src='/icons/left-arrow-black.svg' />
        {!isMobile && (
          <Typography fontSize={'1rem'} color='#131544' marginLeft={'0.6rem'}>
            Back to Memvy.com
          </Typography>
        )}
      </IconButton>
      {!isMobile && (
        <Image
          src={isMobile ? '/images/thread_mobile.svg' : '/images/thread.svg'}
          style={{
            objectFit: 'cover',
            position: 'absolute',
            top: 0,
            left: 0,
            margin: 'auto',
            zIndex: -1,
          }}
          alt='thread'
          fill
          priority
          sizes='100%'
          quality={80}
        />
      )}

      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        width={'100%'}
        maxWidth={'29.5rem'}
        borderRadius={'0.5rem'}
        bgcolor={'#F1F7FA'}
        padding={isMobile ? '1rem' : '2rem'}>
        <Box width={'100%'}>{showScreen()}</Box>
      </Box>
    </Box>
  );
};
